import { render, staticRenderFns } from "./ReviewTaskResetAction.vue?vue&type=template&id=25bd1c4a"
import script from "./ReviewTaskResetAction.vue?vue&type=script&lang=js"
export * from "./ReviewTaskResetAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports